$(document).ready(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };
  if (getUrlParameter("customer_posted") || getUrlParameter("form_type")) {
    if ($("#newsletter-modal").length > 0) {
      $("#newsletter-modal").modal("show");
    }
  }
  if (getUrlParameter("grid")) {
    // console.log(getUrlParameter("grid"));
    $(".drag-btn-filter input[type=range]").val(getUrlParameter("grid"));
    jQuery("#range")
      .attr("class", "plp-view")
      .addClass("list" + getUrlParameter("grid"));
  }

  setInterval(function () {
    var pro_selected_id = $("#selected_id_varinant").val();
    if (pro_selected_id != "") {
      $("#defulat_select_varint option").each(function () {
        if ($(this).val() == pro_selected_id) {
          $(".price__container .original-price").html($(this).data("price"));
        }
      });
    }
  }, 600);
});

// Newsletter Submit button Show/Hide
jQuery(document).ready(function ($) {
  const stateOfNewsLetterModal = $("#newsletter-modal").data("disable-modal");
  if (stateOfNewsLetterModal == "hide" || stateOfNewsLetterModal == "") {
    $("#newsletter-modal").modal("hide");
    localStorage.setItem("isNewsLetterHide", "true");
  } else {
    localStorage.removeItem("isNewsLetterHide");
  }

  let isNewsLetterHide = localStorage.getItem("isNewsLetterHide") || false;
  let isNewsLetterSubscribe =
    localStorage.getItem("isNewsLetterSubscribe") || false;

  // Show/Hide the Newsletter Modal
  if ($("#newsletter-modal").length > 0) {
    if (isNewsLetterHide == "true") {
      // if newsletter hide from backend
      $("#newsletter-modal").modal("hide");
    } else {
      // Hide Newsletter modal when user submit newsletter
      if (isNewsLetterSubscribe == "true") {
        $("#newsletter-modal").modal("hide");
      }

      // Hide the pop-up after 3sec when user submit
      if (isNewsLetterSubscribe == "true") {
        setTimeout(function () {
          $("#newsletter-modal").modal("hide");
        }, 3000);
      }

      // Show newsletter modal when user visit the site after 5sec
      if (!isNewsLetterSubscribe) {
        setTimeout(function () {
          $("#newsletter-modal").modal("show");
        }, 5000);
      }
    }
  }

  // Closing Modal on close button
  $(".rm-btn-close-js").on("click", function () {
    localStorage.setItem('isNewsLetterSubscribe', 'true');
    $("#newsletter-modal").modal("hide");
  });

  // Closing Modal when we click outside of modal content
  $("#newsletter-modal").on("click", function (event) {
    if (!$(event.target).closest(".modal-content").length) {
      $("#newsletter-modal").modal("hide");
    }
  });

  // Showing Submit button when we type coorect email in inpit tag
  $("#contactFormEmail").on("keyup", function (event) {
    const email = event.target.value;
    const errorElement = $(".rm-error-popup-js");
    const submitButton = $(".rm-fc-submit-js");
    const newsLetterLower = $('.rm-newsletter-lower');

    // Regular expression for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email === "") {
      errorElement.removeClass("d-none").text("Email can’t be blank");
      submitButton.removeClass("rm-form-control-submit");
      submitButton.addClass("d-none");
      newsLetterLower.addClass('add-height');
    } else if (
      !emailPattern.test(email)
    ) {
      errorElement
        .removeClass("d-none")
        .text("Please enter a valid email address");
      submitButton.removeClass("rm-form-control-submit");
      submitButton.addClass("d-none");
      newsLetterLower.addClass('add-height');
    } else {
      errorElement.addClass("d-none").text("");
      submitButton.addClass("rm-form-control-submit");
      submitButton.removeClass("d-none");
      newsLetterLower.removeClass('add-height');
    }
  });

  // Clear Input Field
  $(".rm-form-reset-popup-js").on("click", function () {
    $("#contactFormEmail").val("");
    $(".rm-error-popup-js").addClass("d-none").text("");
    $(".rm-fc-submit-js").removeClass("rm-form-control-submit");
    $(".rm-fc-submit-js").addClass("d-none");
  });

  // Icon Info On Click
  $(".rm-info-icon-js").on("click", function () {
    $(".rm-icon-text-js").toggleClass("d-none");
  });

  // Newsletter Ajax Calling
  // $('#newsletter-form').on('submit', function (e) {
  //   e.preventDefault(); // Prevent the default form submission

  //   var email = $('#contactFormEmail').val();
  //   var formData = {
  //     'form_type': 'customer',
  //     'utf8': '✓',
  //     'contact[email]': email
  //   };

  //   $.ajax({
  //     type: 'POST',
  //     url: '/contact',
  //     data: formData,
  //     dataType: 'json',
  //     success: function (response) {
  //       $('#newsletter-form').addClass('d-none');
  //       $('#newsletter-message').removeClass('d-none');
  //       $('#newsletter-message').text('Thank you for subscribing!');
  //       $('#contactFormEmail').val(''); // Clear the email input field

  //       sessionStorage.setItem('isNewsLetterSubscribe', true);
  //     },
  //     error: function (xhr, status, error) {
  //       console.log({xhr, status, error});
  //       $('#newsletter-form').addClass('d-none');
  //       $('#newsletter-message').removeClass('d-none');
  //       $('#newsletter-message').css('color', 'red');
  //       $('#newsletter-message').text('An error occurred. Please try again.');
  //     }
  //   });
  // });
});

/* newsletter */
jQuery(document).ready(function ($) {
  var check_cookie = getCookie("splash");
  if (check_cookie != "") {
    if (jQuery("#imageSplash").length > 0) {
      document.getElementById("imageSplash").classList.add("hide");
    }
  } else {
    jQuery("#imageSplash").show();
    setTimeout(function () {
      setCookie("splash", "splash", 1);
    }, 10000);
  }
  var newsubmit = window.location.href.includes(".com/?contact_posted=true");
  if (newsubmit) {
    jQuery("#newsletter-modal").modal("show");
  }
});

jQuery(document).ready(function () {
  (function () {
    "use strict";

    // document
    //   .querySelector('[data-toggle="offcanvas"]')
    //   .addEventListener("click", function() {
    //     document.querySelector(".offcanvas-collapse").classList.toggle("open");
    //   });
  })();
  // jQuery('.navbar-toggler').on('click', function () {
  //     jQuery(this).toggleClass('change');
  //     jQuery("body").toggleClass('menu-open');
  // });

  //   if(jQuery('body').find('.nav-link.dropdown-toggle.show').length) {
  //       jQuery('body').addClass('menu-open');
  //   } else {
  //       jQuery('body').removeClass('menu-open');
  //   }
  $(".dropdown.search-menu-d .nav-link").on("hide.bs.dropdown", function (e) {
    if (e.clickEvent) {
      e.preventDefault();
    }
  });

  $(".dropdown-menu").on("click", function (event) {
    event.stopPropagation();
  });

  $(document).ready(function () {
    $(".dropdown").on("show.bs.dropdown", function () {
      $(".dropdown").not(this).find(".dropdown-menu").removeClass("show");
      $(".dropdown").not(this).find(".nav-link").removeClass("show");
      $("body").addClass("menu-active");
    });

    $(".dropdown").on("show.bs.dropdown", function () {
      // $('body').addClass('menu-active');
      // $('html').addClass('menu-active');
    });
    $(".dropdown").on("hide.bs.dropdown", function () {
      $("body").removeClass("menu-active");
      // $('html').removeClass('menu-active');
    });

    $(".search-menu-d").on("show.bs.dropdown", function () {
      $("body").addClass("search-menu-active");
    });
    $(".search-menu-d").on("hide.bs.dropdown", function () {
      $("body").removeClass("search-menu-active");
    });
  });

  //  jQuery(".img-wrap img").hover(
  //           function () {
  //               jQuery(this).parent().parent().addClass("post-hover");
  //           }, function () {
  //               jQuery(this).parent().parent().removeClass("post-hover");
  //       });
  if (jQuery(".owl-carousel").length > 0) {
    var owl = jQuery(".campaign-list-slider");
    owl.owlCarousel({
      nav: false,
      dots: false,
      loop: false,
      items: 2,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
    });
    owl.on('drag.owl.carousel', function (event) {
      $('body').css('overflow', 'hidden');
    });

    owl.on('dragged.owl.carousel', function (event) {
      $('body').css('overflow', 'auto');
    });

    // jQuery('.pdp-slider').owlCarousel({
    //     loop: false,
    //     nav: false,
    //     dots: true,
    //     autoplay: true,
    //     autoplayHoverPause: true,
    //     items: 1,
    // });
    // if( jQuery('.home-slider-desk').length > 0 ) {
    //     var owl = jQuery(".home-slider-desk");
    //      owl.owlCarousel({
    //         loop: true,
    //         nav: false,
    //         dots: true,
    //         autoplay: true,
    //         items: 1,
    //         autoplayHoverPause: true,
    //         autoplayTimeout:9000,
    //         animateOut: 'slideOutUp',
    //         animateIn: 'slideInUp',
    //         responsive: {
    //           0: {
    //             items: 1,
    //             mouseDrag: false,
    //              loop: false,
    //             touchDrag: true
    //           },
    //           991:{
    //             items: 1,
    //              loop: true,
    //           }
    //         }
    //     });
    //   //safari
    //     jQuery(window).scroll(function(e) {
    //         if (e.originalEvent.wheelDelta >0) {
    //            owl.trigger('prev.owl.carousel');
    //         } else {
    //             owl.trigger('next.owl.carousel');
    //         }
    //         e.preventDefault();
    //     });
    //   //Firefox:
    //     owl.on('DOMMouseScroll','.owl-stage',function(e){
    //         if (e.originalEvent.detail > 0){
    //             owl.trigger('prev.owl.carousel');
    //             } else {
    //             owl.trigger('next.owl.carousel');
    //         }
    //         e.preventDefault();
    //         });
    //     //Chrome, IE
    //     owl.on('mousewheel', '.owl-stage', function (e) {
    //         if (e.originalEvent.wheelDelta >0) {
    //            owl.trigger('prev.owl.carousel');
    //         } else {
    //             owl.trigger('next.owl.carousel');
    //         }
    //         e.preventDefault();
    //     });

    //     // owl.on('mousewheel', '.owl-stage', function (e) {
    //     //     if (e.deltaY>0) {
    //     //         owl.trigger('prev.owl');
    //     //     } else {
    //     //         owl.trigger('next.owl');
    //     //     }
    //     //     e.preventDefault();
    //     // });
    // }

    if (jQuery(window).width() < 768) {
      jQuery(".craft-img-wrap").owlCarousel({
        nav: false,
        dots: false,
        loop: false,
        items: 2,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
      });
    }
  }

  // jQuery(".click-btn").click(function() {
  //   init_full_slider_div();
  //     // jQuery('html, body').animate({
  //     //     scrollTop: jQuery("#home-slider").offset().top
  //     // }, 2000);

  // });
  //   jQuery(window).resize()
  //   jQuery(".mob-link").attr("src","assets/images/right-arrow.svg");
  //   jQuery('.shopify-challenge__container').addClass('section-padding-t section-padding-b');

  //     if( jQuery('.newsletter-modal').length > 0 ){
  // //       jQuery('#newsletter-modal').modal('hide');
  // //       setTimeout(function() {
  // //           jQuery('.newsletter-modal.show-maodal').modal('show');
  // //       }, 5000);

  //     jQuery('#newsletter-modal').modal('hide');
  //     setTimeout(function() {
  //       jQuery('input[type=checkbox]:checked ~ #newsletter-modal').modal('show');
  //     }, 5000);
  //   }

  // .section-padding-t.scrollup

  if (jQuery(".my-acc-accordian .theme-btn2").length > 0) {
    var toTop = jQuery(".my-acc-accordian .theme-btn2");
    // logic
    toTop.on("click", function () {
      jQuery(".edit-account").animate({
        scrollTop: jQuery(".edit-account").offset().top,
      });
    });
  }
  // if( jQuery('.shopping-page .counter-btn-grp').length > 0 ) {
  //     jQuery('.page-footer ').addClass('fb-spacing');
  // }
  // jQuery(".dropdown-menu.accordion").click(function(e){
  //     e.stopPropagation();
  // });

  // document.addEventListener("DOMContentLoaded", function(){
  //     /////// Prevent closing from click inside dropdown
  //     document.querySelectorAll('.dropdown-menu').forEach(function(element){
  //         element.addEventListener('click', function (e) {
  //         e.stopPropagation();
  //         });
  //     })
  // });
  jQuery(window).scroll(function () {
    if (jQuery(document).scrollTop() < 1) {
      jQuery("body").addClass("fixed-filter");
      //   alert("abc");
    } else {
      jQuery("body").removeClass("fixed-filter");
    }
  });
});

jQuery(window).resize(function (e) {
  if (jQuery(window).width() <= 1200) {
    jQuery(".mob-link").attr("src", "assets/images/right-arrow.svg");
  } else {
    jQuery(".mob-link").attr("src", "assets/images/right-arrow-white.svg");
  }
});

// jQuery(window).scroll(function(){
//   if (jQuery(window).scrollTop() >= 300) {
//       jQuery('.navbar ').addClass('fixed');
//   }
//   else {
//       jQuery('.navbar ').removeClass('fixed');
//   }
// });

if (jQuery(".sl-fixed").length > 0) {
  var lastScroll = 0;
  var isScrolled = false;
  window.addEventListener("scroll", function () {
    var topHeader = document.querySelector(".sl-fixed");
    var currentScroll =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    var scrollDirection = currentScroll < lastScroll;
    var shouldToggle = isScrolled && scrollDirection;
    var w = $(window).width();
    if (w > 767) {
      isScrolled = currentScroll > 300;
    }
    else {
      isScrolled = currentScroll > 70;
    }

    topHeader.classList.toggle("fixed", shouldToggle);
    lastScroll = currentScroll;
  });
}
// add fixed to secondary nav ends
if (jQuery(".custom-select").length > 0) {
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }
  function closeAllSelect(elmnt) {
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  document.addEventListener("click", closeAllSelect);
}

// splash screen
if (jQuery("#imageSplash").length > 0) {
  var element = document.getElementById("imageSplash");

  element.addEventListener("mousewheel", MouseWheelHandler, false);
  element.addEventListener("DOMMouseScroll", MouseWheelHandler, false);
  // element.addEventListener("touchstart", MouseWheelHandler, false);
  element.addEventListener("touchmove", MouseWheelHandler, false);
  function MouseWheelHandler(e) {
    element.classList.add("hide");

    document.getElementById("clickScroll").checked = true;
    // document.getElementById("home-slider").classList.add('show');
    document.getElementById("newsletter-modal").classList.add("show-maodal");
    if (jQuery(".home").length > 0) {
      init_full_slider_div();
    }
    return false;
  }
}

// function init_full_slider_div() {
//   setTimeout(function () {
//     if ($(window).width() > 1190) {
//       if ($("#fullpage").length > 0) {
//         var myFullpage = new fullpage("#fullpage", {
//           verticalCentered: true,
//           navigation: true,
//           // scrollBar: true,
//           // css3: true,
//           // scrollingSpeed: 200,
//           //   touchSensitivity: 15,
//           // scrollOverflow: true,
//         });
//       }
//     }
//     if ($(window).width() < 1190) {
//       var myFullpage = new fullpage("#fullpage", {
//         verticalCentered: true,
//         navigation: true,
//         scrollBar: false,
//       });
//     }
//   }, 500);
// }

function init_full_slider_div() {
  setTimeout(function () {
    if ($(window).width() > 1190) {
      if ($("#fullpage").length > 0) {
        var myFullpage = new fullpage("#fullpage", {
          verticalCentered: true,
          navigation: true,
          //scrollingSpeed: 700, // Adjust the speed if needed
          scrollBar: false,
          afterLoad: function (origin, destination, direction) {
            // Prevent multiple sections from being skipped
            fullpage_api.setAllowScrolling(false);
            setTimeout(function () {
              fullpage_api.setAllowScrolling(true);
            }, 700); // Adjust time to match scrollingSpeed
          },
        });
      }
    } else {
      // var myFullpage = new fullpage("#fullpage", {
      //   verticalCentered: true,
      //   navigation: true,
      //   scrollBar: false,
      //   scrollingSpeed: 700, // Same speed as above for consistency
      //   afterLoad: function (origin, destination, direction) {
      //     // Prevent multiple sections from being skipped
      //     fullpage_api.setAllowScrolling(false);
      //     setTimeout(function () {
      //       fullpage_api.setAllowScrolling(true);
      //     }, 700); // Adjust time to match scrollingSpeed
      //   },
      // });
    }
  }, 500);
}

//range slider PLP
if (jQuery(".sari-listing-wrap").length > 0) {
  jQuery(function () {
    const cssClasses = [
      "rangeslider--is-lowest-value",
      "rangeslider--is-mid-value",
      "rangeslider--is-highest-value",
    ];

    jQuery("input[type=range]")
      .rangeslider({
        polyfill: false,
      })
      .on("input", function () {
        const fraction = (this.value - this.min) / (this.max - this.min);
        if (fraction === 0) {
          this.nextSibling.classList.add(cssClasses[0]);
        } else if (fraction === 1) {
          this.nextSibling.classList.add(cssClasses[1]);
        } else if (fraction === 1) {
          this.nextSibling.classList.add(cssClasses[2]);
        } else {
          this.nextSibling.classList.remove(...cssClasses);
        }
      });
  });
}

// calender for edit account
const getDatePickerTitle = (elem) => {
  // From the label or the aria-label
  const label = elem.nextElementSibling;
  let titleText = "";
  if (label && label.tagName === "LABEL") {
    titleText = label.textContent;
  } else {
    titleText = elem.getAttribute("aria-label") || "";
  }
  return titleText;
};

const elems = document.querySelectorAll(".datepicker_input");
for (const elem of elems) {
  const datepicker = new Datepicker(elem, {
    format: "dd/mm/yyyy", // UK format
    title: getDatePickerTitle(elem),
  });
}

jQuery(($) => {
  if (window.location.hash) {
    var hash = window.location.hash;
    $(hash).collapse("show").animate(
      {
        scrollTop: 0,
      },
      2000
    );
  }
});

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

if (jQuery(".fixed-section").length > 0) {
  function isInView(el) {
    let box = el.getBoundingClientRect();
    return box.top < window.innerHeight && box.bottom >= 0;
  }

  window.addEventListener("scroll", function () {
    var footer = document.getElementById("shopify-section-footer-rawmango");
    var body = document.getElementById("fixed-section");
    var visible = isInView(footer);
    if (visible) {
      body.classList.add("hide");
    } else {
      body.classList.remove("hide");
    }

  });
}

/* filters */
function initSort() {
  if ($("#sort-by").length > 0) {
    var selectedsort = $("#sort-by").data("sorted");

    if (selectedsort !== undefined && selectedsort !== "") {
      $("#sort-by option[value='" + selectedsort + "']").attr("selected", "selected");
    }
  }
}

initSort();

const filter_array_store =
  JSON.parse(sessionStorage.getItem("filter_attributes")) || [];

// If any item not present in filter session Storage then we add manual in sort by
if (filter_array_store.length === 0) {
  console.log("Empty filter session");
  sessionStorage.setItem(
    "filter_attributes",
    JSON.stringify(['manual'])
  );
  $(".accordion-body li").each(function () {
    if ($(this).data("filter-value") === 'manual') {
      $(this).addClass("active");
    }
  });
}
FilterCount();

function FilterCount() {
  let count = $(".accordion-body li.active").length;
  if (count > 0) {
    $(".filter_count-js").html(`[${count}]`);
  } else {
    $(".filter_count-js").html(``);
  }
}

filter_array_store.forEach(function (value) {
  $(".accordion-body li").each(function () {
    if (value === $(this).data("filter-value")) {
      $(this).addClass("active");
    }
  });
  FilterCount();
});

// Toggle active class for accordion items when clicked
jQuery(".accordion-body li").on("click", function () {
  if ($(this).data("group") === "Sort By") {
    if ($(this).hasClass("active")) {
      $('.accordion-body li[data-group="Sort By"]').removeClass("active");
    } else {
      $('.accordion-body li[data-group="Sort By"]').removeClass("active");
      $(this).toggleClass("active");
    }
  } else if ($(this).data("group") === "size") {
    if ($(this).hasClass("active")) {
      $('.accordion-body li[data-group="size"]').removeClass("active");
    } else {
      $('.accordion-body li[data-group="size"]').removeClass("active");
      $(this).toggleClass("active");
    }
  } else if ($(this).data("group") === "Colour Family") {
    if ($(this).hasClass("active")) {
      $('.accordion-body li[data-group="Colour Family"]').removeClass("active");
    } else {
      $('.accordion-body li[data-group="Colour Family"]').removeClass("active");
      $(this).toggleClass("active");
    }
  }
  else if ($(this).data("group") === "Textile") {
    if ($(this).hasClass("active")) {
      $('.accordion-body li[data-group="Textile"]').removeClass("active");
    } else {
      $('.accordion-body li[data-group="Textile"]').removeClass("active");
      $(this).toggleClass("active");
    }
  }
  else if ($(this).data("group") === "Product Type") {
    if ($(this).hasClass("active")) {
      $('.accordion-body li[data-group="Product Type"]').removeClass("active");
    } else {
      $('.accordion-body li[data-group="Product Type"]').removeClass("active");
      $(this).toggleClass("active");
    }
  }
  else {
    $(this).toggleClass("active");
  }

  FilterCount();
});

jQuery("#apply-sort-filter").on("click", function () {
  //var curpath = document.location.pathname + document.location.search;
  var curpath = document.location.pathname;
  var $filters = jQuery(".filter-by");
  var newTags = [];
  let storeFilterAttribute = [];
  let SortBy = "";
  let SizeBy = "";
  let ProductType = "";
  $filters.each(function () {
    if (jQuery(this).val()) {
      newTags.push(jQuery(this).val());
    }
  });

  // Collect filter values from active accordion items
  $(".accordion-body li.active").each(function () {
    if ($(this).data("filter-value") !== "") {
      if ($(this).data("group") === "Sort By") {
        SortBy = $(this).data("filter-value");
      }
      else if ($(this).data("group") === "size") {
        SizeBy = $(this).data("filter-value");
      }
      // else if ($(this).data("group") === "Product Type") {
      //   ProductType = $(this).data("filter-value");
      // }
      else if ($(this).data("filter-value") !== "") {
        newTags.push($(this).data("filter-value"));
      }
    }
  });

  if (newTags.length) {
    var query = newTags.join("+");
    curpath =
      jQuery("#filter").data("collection") +
      jQuery("#filter").data("collection-handle") +
      "/" +
      query;
  }

  if (ProductType) {
    curpath =
      jQuery("#filter").data("collection") +
      jQuery("#filter").data("collection-handle") +
      "/" +
      ProductType;
  }

  if (SortBy) {
    if (curpath.indexOf("sort_by") >= 0) {
      curpath = curpath.replace(
        /sort_by=.+/g,
        "sort_by=" +
        `${jQuery("#sort-by").val() ? jQuery("#sort-by").val() : SortBy}`
      );
    } else {
      curpath =
        curpath +
        (curpath.indexOf("?") >= 0 ? "&" : "?") +
        "sort_by=" +
        `${jQuery("#sort-by").val() ? jQuery("#sort-by").val() : SortBy}`;
    }
  }


  if (SizeBy) {
    if (curpath.indexOf("size_by") >= 0) {
      curpath = curpath.replace(/size_by=.+/g, "size_by=" + `${SizeBy}`);
    } else {
      curpath =
        curpath +
        (curpath.indexOf("?") >= 0 ? "&" : "?") +
        "size_by=" +
        `${SizeBy}`;
    }
  }

  const filteredValues = [...newTags, SortBy, SizeBy, ProductType].filter((value) => {
    return value !== "";
  });

  storeFilterAttribute = filteredValues;

  sessionStorage.setItem(
    "filter_attributes",
    JSON.stringify(storeFilterAttribute)
  );

  document.location.href = curpath;
});

jQuery("#clear-sort-filter").on("click", function () {
  document.location.href =
    document.location.origin +
    jQuery("#filter").data("collection") +
    jQuery("#filter").data("collection-handle");
  sessionStorage.removeItem("filter_attributes");
});

$(".db-button").each(function () {
  let getGridValue = sessionStorage.getItem("grid-position") || 2;

  if ($(this).data("grid-value") == getGridValue) {
    $('#range').addClass(`list${getGridValue}`);
    $(this).addClass("active");
  }
});

$(".db-button").on("click", function () {
  $(".db-button").removeClass("active");
  $(this).addClass("active");
  sessionStorage.setItem("grid-position", $(this).data("grid-value"));
});

/* cart&minicart*/
jQuery("#main-cart-items .quantity__button").on("click", function () {
  setTimeout(function () {
    document.location.href = document.location.href;
  }, 850);
});

jQuery("#bag .quantity__button").on("click", function () {
  var id = jQuery(this).data("key");
  var qt = jQuery(this).data("qty");
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: { id: id, quantity: qt },
    dataType: "json",
    success: function (cart) {
      // Private general variables
      var Shopify = Shopify || {};
      // ---------------------------------------------------------------------------
      // Money format handler
      // ---------------------------------------------------------------------------
      Shopify.money_format = "${{amount}}";
      Shopify.formatMoney = function (cents, format) {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || this.money_format;

        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      };
      var settings;
      settings = {
        moneyFormat: "RS. {{amount}}",
      };
      // console.log(cart);
      jQuery(".item_count").html(cart.item_count);
      var items = cart.items;
      items.forEach(itemfunction);
      function itemfunction(item) {
        // console.log(item.id);
        //alert('#'+item.id+ ' .quantity__button.minus');
        jQuery("#" + item.id + " .quantity__button.minus").attr(
          "data-qty",
          item.quantity - 1
        );
        jQuery("#" + item.id + " .quantity__button.plus").attr(
          "data-qty",
          item.quantity + 1
        );
        jQuery("#" + item.id + " .items-info .price").html(
          Shopify.formatMoney(item.final_line_price, settings.moneyFormat)
        );
        // console.log(item.quantity - 1);
        // console.log(
        //   Shopify.formatMoney(item.final_line_price, settings.moneyFormat)
        // );
      }

      //jQuery('#bag .quantity__button.minus').
      //jQuery('#bag .quantity__button.plus').
      jQuery(".mini-total-price").html(
        Shopify.formatMoney(cart.total_price, settings.moneyFormat)
      );
      // alert('There are now ' + cart.item_count + ' items in the cart.');
    },
  });
});

// window.addEventListener("pageshow", function (event) {
//   var historyTraversal =
//     event.persisted ||
//     (typeof window.performance != "undefined" &&
//       window.performance.navigation.type === 2);
//   if (historyTraversal) {
//     // Handle page restore.
//     //alert('refresh');
//     window.location.reload();
//   }
// });
jQuery("#main-cart-items .remove").on("click", function () {
  setTimeout(function () {
    window.location.reload();
  }, 1300);
});

if (jQuery(".product-right").length > 0) {
  jQuery(".product-img--main")
    .on("mouseover", function () {
      jQuery(this)
        .children(".product-img--main__image")
        .css({ transform: "scale(" + jQuery(this).attr("data-scale") + ")" });
    })
    .on("mouseout", function () {
      jQuery(this)
        .children(".product-img--main__image")
        .css({ transform: "scale(1)" });
    })
    .on("mousemove", function (e) {
      jQuery(this)
        .children(".product-img--main__image")
        .css({
          "transform-origin":
            ((e.pageX - jQuery(this).offset().left) / jQuery(this).width()) *
            100 +
            "% " +
            ((e.pageY - jQuery(this).offset().top) / jQuery(this).height()) *
            100 +
            "%",
        });
    })
    .each(function () {
      jQuery(this)
        .append('<div class="product-img--main__image"></div>')
        .children(".product-img--main__image")
        .css({
          "background-image": "url(" + jQuery(this).attr("data-image") + ")",
        });
    });
}

$(".dropdown").click(function (e) {
  // e.preventDefault();
  // e.stopPropagation();
});

$("#btnClose").click(function () {
  $(this).parents(".dropdown").find("#search-menu").dropdown("toggle");
});

$(".my-acc-tab .dropdown-menu li a").click(function () {
  $(this)
    .parents(".dropdown")
    .find(".dropdown-toggle")
    .html($(this).text() + ' <span class="caret"></span>');
  $(this)
    .parents(".dropdown")
    .find(".dropdown-toggle")
    .val($(this).data("value"));
});

if (jQuery(".galleryModal").length > 0) {
  jQuery(".galleryModal").on("shown.bs.modal", function (e) {
    jQuery(".galleryModalSlider").slick("setPosition");
    // jQuery('.wrap-modal-slider').addClass('open');
  });
  // debounce from underscore.js
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // use x and y mousewheel event data to navigate flickity
  function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
    // do not trigger a slide change if another is being animated
    if (!slick_is_animating) {
      // pick the larger of the two delta magnitudes (x or y) to determine nav direction
      var direction =
        Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

      // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

      if (direction > 0) {
        // next slide
        slick_instance.slick("slickNext");
      } else {
        // prev slide
        slick_instance.slick("slickPrev");
      }
    }
  }

  // debounce the wheel event handling since trackpads can have a lot of inertia
  var slick_handle_wheel_event_debounced = debounce(
    slick_handle_wheel_event,
    40,
    true
  );

  // init slider
  // if (jQuery(".slides").length > 0) {
  //   const slick_2 = jQuery(".slides");
  //   slick_2.slick({
  //     dots: false,
  //     vertical: true,
  //     verticalSwiping: false,
  //     arrows: false,
  //     centerMode: true,
  //     centerPadding: "0px",
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     infinite: false,
  //     touchThreshold: 1, // chang
  //     speed: 600, // Speed of the scroll, adjust to your liking
  //     cssEase: "linear", // Smooth scrolling effect
  //     touchMove: true,
  //     swipe: true,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //           swipe: true,
  //           draggable: true,
  //           touchThreshold: 10,
  //           verticalSwiping: true,
  //         }
  //       }
  //     ],
  //   });
  //   var slick_2_is_animating = false;

  //   slick_2.on("afterChange", function (index) {
  //     // console.log("Slide after change " + index);
  //     slick_2_is_animating = false;
  //   });

  //   slick_2.on("beforeChange", function (index) {
  //     // console.log("Slide before change " + index);
  //     slick_2_is_animating = true;
  //   });

  //   let scrollTimeout;
  //   let isAnimating = false; // Lock to prevent multiple slide scrolls
  //   const scrollThreshold = 10; // Minimum deltaY value to trigger a scroll

  //   slick_2.on("wheel", function (e) {
  //     e.preventDefault(); // Prevent default scrolling

  //     // Ignore scrolls while animation is in progress
  //     if (isAnimating) return;

  //     // Use only significant scrolls to avoid delays on touchpads
  //     if (Math.abs(e.originalEvent.deltaY) < scrollThreshold) return;

  //     clearTimeout(scrollTimeout);
  //     scrollTimeout = setTimeout(function () {
  //       isAnimating = true; // Lock scroll during transition

  //       if (e.originalEvent.deltaY < 0) {
  //         slick_2.slick("slickPrev");
  //       } else {
  //         slick_2.slick("slickNext");
  //       }

  //       // Unlock after slide transition completes
  //       setTimeout(() => {
  //         isAnimating = false;
  //       }, 400); // Adjust to match your slider’s speed
  //     }, 25); // Lower debounce for quicker response on touchpads
  //   });


  //   // Handle touch event for touch screens (laptops/tablets)
  //   let startY;
  //   slick_2.on("touchstart", function (event) {
  //     startY = event.originalEvent.touches[0].clientY;
  //   });

  //   slick_2.on("touchmove", function (event) {
  //     if (!isScrolling) {
  //       let endY = event.originalEvent.touches[0].clientY;
  //       if (startY - endY > 50) {
  //         isScrolling = true; // Set the flag to true
  //         slick_2.slick("slickNext"); // Swipe up to next slide
  //         setTimeout(() => {
  //           isScrolling = false; // Reset the flag after a timeout
  //         }, 0); // Adjust the timeout duration as needed
  //       } else if (startY - endY < -50) {
  //         isScrolling = true; // Set the flag to true
  //         slick_2.slick("slickPrev"); // Swipe down to previous slide
  //         setTimeout(() => {
  //           isScrolling = false; // Reset the flag after a timeout
  //         }, 0); // Adjust the timeout duration as needed
  //       }
  //     }
  //   });

  //   // Optional: Reset to the next slide if swiped multiple times quickly
  //   slick_2.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
  //     if (Math.abs(nextSlide - currentSlide) > 1) {
  //       slick.slickGoTo(nextSlide); // Force the next slide if skipped
  //     }
  //   });
  // }
  // if (jQuery(".slides").length > 0) {
  //   const slick_2 = jQuery(".slides");
  //   let isScrolling = false; // Flag to prevent multiple rapid scrolling

  //   slick_2.slick({
  //     dots: false,
  //     lazyLoad: 'ondemand',
  //     arrows: false,
  //     vertical: true,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     verticalSwiping: false,
  //     infinite: false,
  //     swipeToSlide: true,
  //     mobileFirst: true,
  //     touchThreshold: 2,
  //     speed: 1000,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //           swipe: true,
  //           draggable: true,
  //           touchThreshold: 10,
  //           verticalSwiping: true,
  //         }
  //       }
  //     ]
  //   });

  //   let scrollTimeout;
  //   let isAnimating = false; // Lock to prevent multiple slide scrolls
  //   const scrollThreshold = 10; // Minimum deltaY value to trigger a scroll

  //   slick_2.on("wheel", function (e) {
  //     e.preventDefault(); // Prevent default scrolling

  //     // Ignore scrolls while animation is in progress
  //     if (isAnimating) return;

  //     // Use only significant scrolls to avoid delays on touchpads
  //     if (Math.abs(e.originalEvent.deltaY) < scrollThreshold) return;

  //     clearTimeout(scrollTimeout);
  //     scrollTimeout = setTimeout(function () {
  //       isAnimating = true; // Lock scroll during transition

  //       if (e.originalEvent.deltaY < 0) {
  //         slick_2.slick("slickPrev");
  //       } else {
  //         slick_2.slick("slickNext");
  //       }

  //       // Unlock after slide transition completes
  //       setTimeout(() => {
  //         isAnimating = false;
  //       }, 400); // Adjust to match your slider’s speed
  //     }, 25); // Lower debounce for quicker response on touchpads
  //   });

  //   // Handle touch event for touch screens (laptops/tablets)
  //   let startY;
  //   slick_2.on("touchstart", function (event) {
  //     startY = event.originalEvent.touches[0].clientY;
  //   });

  //   slick_2.on("touchmove", function (event) {
  //     if (!isScrolling) {
  //       let endY = event.originalEvent.touches[0].clientY;
  //       if (startY - endY > 50) {
  //         isScrolling = true; // Set the flag to true
  //         slick_2.slick("slickNext"); // Swipe up to next slide
  //         setTimeout(() => {
  //           isScrolling = false; // Reset the flag after a timeout
  //         }, 0); // Adjust the timeout duration as needed
  //       } else if (startY - endY < -50) {
  //         isScrolling = true; // Set the flag to true
  //         slick_2.slick("slickPrev"); // Swipe down to previous slide
  //         setTimeout(() => {
  //           isScrolling = false; // Reset the flag after a timeout
  //         }, 0); // Adjust the timeout duration as needed
  //       }
  //     }
  //   });

  //   // Optional: Reset to the next slide if swiped multiple times quickly
  //   slick_2.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
  //     if (Math.abs(nextSlide - currentSlide) > 1) {
  //       slick.slickGoTo(nextSlide); // Force the next slide if skipped
  //     }
  //   });
  // }

  if (jQuery(".slides").length > 0) {
    // debounce from underscore.js
    function debounce(func, wait, immediate) {
      console.log("debounce wheel run");
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };

    // use x and y mousewheel event data to navigate flickity
    function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
      // do not trigger a slide change if another is being animated
      if (!slick_is_animating) {
        // pick the larger of the two delta magnitudes (x or y) to determine nav direction
        var direction =
          Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

        // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

        if (direction > 0) {
          // next slide
          slick_instance.slick("slickNext");
        } else {
          // prev slide
          slick_instance.slick("slickPrev");
        }
      }
    }

    // debounce the wheel event handling since trackpads can have a lot of inertia
    var slick_handle_wheel_event_debounced = debounce(
      slick_handle_wheel_event
      , 40, true
    );

    // init slider 
    const slick_2 = $(".slides");
    slick_2.slick({
      dots: false,
      vertical: true,
      infinite: false,
      // verticalSwiping: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            swipe: true,
            draggable: true,
            touchThreshold: 10,
            verticalSwiping: true,
          }
        }
      ],
    });
    var slick_2_is_animating = false;

    slick_2.on("afterChange", function (index) {
      // console.log("Slide after change " + index);
      slick_2_is_animating = false;
    });

    slick_2.on("beforeChange", function (index) {
      // console.log("Slide before change " + index);
      slick_2_is_animating = true;
    });

    slick_2.on("wheel", function (e) {
      slick_handle_wheel_event_debounced(e.originalEvent, slick_2, slick_2_is_animating);
    });

    // Handle touch event for touch screens (laptops/tablets)
    let startY;
    slick_2.on("touchstart", function (event) {
      startY = event.originalEvent.touches[0].clientY;
    });

    slick_2.on("touchmove", function (event) {
      if (!isScrolling) {
        let endY = event.originalEvent.touches[0].clientY;
        if (startY - endY > 50) {
          isScrolling = true; // Set the flag to true
          slick_2.slick("slickNext"); // Swipe up to next slide
          setTimeout(() => {
            isScrolling = false; // Reset the flag after a timeout
          }, 0); // Adjust the timeout duration as needed
        } else if (startY - endY < -50) {
          isScrolling = true; // Set the flag to true
          slick_2.slick("slickPrev"); // Swipe down to previous slide
          setTimeout(() => {
            isScrolling = false; // Reset the flag after a timeout
          }, 0); // Adjust the timeout duration as needed
        }
      }
    });

  }



  $(".galleryModalSlider")
    .on("afterChange init", function (event, slick, direction) {
      // console.log("afterChange/init", event, slick, slick.$slides);
      // remove all prev/next
      slick.$slides.removeClass("prevdiv").removeClass("nextdiv");

      // find current slide
      for (var i = 0; i < slick.$slides.length; i++) {
        var $slide = $(slick.$slides[i]);
        if ($slide.hasClass("slick-current")) {
          // update DOM siblings
          $slide.prev().addClass("prevdiv");
          $slide.next().addClass("nextdiv");
          break;
        }
      }
    })
    .on("beforeChange", function (event, slick) {
      // optional, but cleaner maybe
      // remove all prev/next
      slick.$slides.removeClass("prevdiv").removeClass("nextdiv");
    });

  $(".campaign-list .single-block").click(function () {
    $(".slides").slick("slickGoTo", $(this).index());
  });
}

if ($(window).width() > 1199) {
  if (jQuery(".home").length > 0) {
    // console.log('Window Above 1199px');
    if ($("#fullpage").length > 0) {
      // console.log('Custom Full Page Load');
      var check_cookie = getCookie("splash");
      var myFullpage = new fullpage("#fullpage", {
        verticalCentered: true,
        navigation: true,
        scrollingSpeed: 1000,
        slidesNavigation: true,
        //fitToSection: true,
        //scrollBar: true,
        css3: true,
        // scrollingSpeed: 200,
        //   touchSensitivity: 15,
        // scrollOverflow: true,
        afterLoad: function (origin, destination, direction) {
          //console.log(destination.item.id);
          var lastSection = document.querySelectorAll(
            ".section:last-of-type"
          )[0];
          var lastSectionId = lastSection.id;

          console.log(lastSectionId);
          var footerSection = destination.item.id === lastSectionId;

          // Hide dots when in the footer section
          if (footerSection) {
            document.querySelector(".fp-right").style.display = "none";
          } else {
            document.querySelector(".fp-right").style.display = "block";
          }
        },
        // onLeave: function (origin, destination, direction) {
        //   // Disabling fullPage scrolling for a short time to avoid skipping sections
        //   fullpage_api.setAllowScrolling(false);
        //   setTimeout(function () {
        //     fullpage_api.setAllowScrolling(true);
        //   }, 800); // Adjust timeout according to scrolling speed
        // },
      });
      if ($("#fullpage").hasClass("splash-remove") || check_cookie != "") {
        // console.log("Has splash remove");
      }
    }

    let isScrolling = false;

    window.addEventListener(
      "wheel",
      function (e) {
        if (!isScrolling) {
          isScrolling = true;
          setTimeout(() => {
            isScrolling = false;
          }, 500); // Adjust according to your speed
        }
      },
      { passive: false }
    );
  }
}


// Mobile view
// if ($(".home").length > 0) {
//   if ($(window).width() < 1190) {
//     var check_cookie = getCookie("splash");
//     if ($("#fullpage").hasClass("splash-remove") || check_cookie != "") {
//       var myFullpage = new fullpage("#fullpage", {
//         verticalCentered: true,
//         navigation: true,
//         scrollBar: false,
//       });
//     }
//   }
// }

$(document).ready(function () {
  // fullpage_api.moveSectionDown();
});

$(window).scroll(function () {
  $("body").removeClass("viewport-bottom");
  if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
    //you are at bottom
    $("body").addClass("viewport-bottom");
  }
});

$(window).on("load", function () {
  //$(window).scrollTop(0);
});
$(document).ready(function () {
  if ($(".zoom").length > 0) {
    $(".zoom").mousemove(function (e) {
      zoom(e);
      // alert("hr")
    });

    function zoom(e) {
      var x, y;
      var zoomer = e.currentTarget;
      if (e.offsetX) {
        offsetX = e.offsetX;
      } else {
        offsetX = e.touches[0].pageX;
      }

      if (e.offsetY) {
        offsetY = e.offsetY;
      } else {
        offsetX = e.touches[0].pageX;
      }
      x = (offsetX / zoomer.offsetWidth) * 100;
      y = (offsetY / zoomer.offsetHeight) * 100;
      zoomer.style.backgroundPosition = x + "% " + y + "%";
    }
  }
});
function funcreload() {
  setTimeout(function () {
    window.location.reload();
  }, 100);
}
$(document).ready(function () {
  checkitem();
  $(".drag-btn-filter").css("visibility", "visible");
});

$("#pro-detailslider").on("slid.bs.carousel", checkitem);

function checkitem() {
  var $this = $("#pro-detailslider");
  if ($(".carousel-inner .carousel-item:first").hasClass("active")) {
    // Hide left arrow
    $this.children(".carousel-control-prev").hide();
    // But show right arrow
    $this.children(".carousel-control-next").show();
  } else if ($(".carousel-inner .carousel-item:last").hasClass("active")) {
    // Hide right arrow
    $this.children(".carousel-control-next").hide();
    // But show left arrow
    $this.children(".carousel-control-prev").show();
  } else {
    $this.children(".carousel-control-next").show();
    $this.children(".carousel-control-prev").show();
  }
}
if ($("#pro-detailslider").length > 0) {
  var myCarousel = document.querySelector("#pro-detailslider");
  var carousel = new bootstrap.Carousel(myCarousel, {
    wrap: false,
  });
}

// var myCollapsible = document.getElementById('collapse1')
// myCollapsible.addEventListener('hidden.bs.collapse', function () {
//  $(".card-header").addClass("hide");
// })

// var myCollapsible = document.getElementById('collapse1')
// myCollapsible.addEventListener('shown.bs.collapse', function () {
//  $(".card-header").removeClass("hide");
// })

$("#my-acc")
  .on("show.bs.collapse", function (e) {
    $(e.target).prev(".card-header").addClass("active");
  })
  .on("hide.bs.collapse", function (e) {
    $(e.target).prev(".card-header").removeClass("active");
  });

// offcanavs code
// var myOffcanvas = document.getElementById('filter')
// myOffcanvas.addEventListener('show.bs.offcanvas', function () {
//   $('html').addClass('offcanvas-active');
// })
// myOffcanvas.addEventListener('hide.bs.offcanvas', function () {
//   $('html').removeClass('offcanvas-active');
// })

// var myOffcanvas1 = document.getElementById('bag')
// myOffcanvas1.addEventListener('show.bs.offcanvas', function () {
//   $('html').addClass('offcanvas-active');
// })
// myOffcanvas1.addEventListener('hide.bs.offcanvas', function () {
//   $('html').removeClass('offcanvas-active');
// })

// Volume Controls
$(document).ready(function () {
  let setIntervalInForDesktop = "";
  let setIntervalInForMobile = "";

  // VolumeCodeForDesktop();
  // VolumeCodeForMobile();

  // $(window).on("resize", function () {
  //   VolumeCodeForDesktop();
  //   VolumeCodeForMobile();
  // });

  $(window).on("scroll", function () {
    const windowTop = $(window).scrollTop();
    if ($(window).width() <= 767) {
      // for Mobile
      // if (windowTop >= 200) {
      //   // console.log("Mobile Pause Video");
      //   PauseVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
      // } else {
      //   // console.log("Mobile Play Video");
      //   PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
      // }
      PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
    } else {
      // for Desktop
      // if (windowTop >= 200) {
      //   // console.log("Desktop Pause Video");
      //   PauseVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-desk-js");
      // } else {
      //   // console.log("Desktop Play Video");
      //   PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-desk-js");
      // }
      PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-desk-js");
    }
  });

  video_mute_unmute(".rm-unmute-js", ".rm-mute-js", ".rm-video-desk-js");
  video_mute_unmute(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");

  // function VolumeCodeForDesktop() {
  //   if ($(window).width() > 1199) {
  //     setIntervalInForDesktop = setInterval(function () {
  //       if ($("#section0").hasClass("swiper-slide-active")) {
  //         PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-desk-js");
  //         // PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
  //       } else {
  //         PauseVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-desk-js");
  //         // PauseVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
  //       }
  //     }, 10);
  //   } else {
  //     clearInterval(setIntervalInForDesktop);
  //   }
  // }

  // function VolumeCodeForMobile() {
  //   if ($(window).width() <= 1199) {
  //     setIntervalInForMobile = setInterval(function () {
  //       if ($("#section0").hasClass("swiper-slide-active")) {
  //         PlayVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
  //       } else {
  //         PauseVideo(".rm-unmute-js", ".rm-mute-js", ".rm-video-mob-js");
  //       }
  //     }, 10);
  //   } else {
  //     clearInterval(setIntervalInForMobile);
  //   }
  // }

  function PauseVideo(unmuteId, muteId, videoId) {
    const videoElement = $(videoId);
    if (videoElement.length > 0) {
      let rm_unmute = $(unmuteId);
      let rm_mute = $(muteId);
      let video = $(videoId)[0];
      if (video) {
        video.pause();
        rm_unmute.css("display", "none");
        rm_mute.css("display", "block");
        video.muted = true;
      }
    }
  }

  function PlayVideo(unmuteId, muteId, videoId) {
    const videoElement = $(videoId);
    if (videoElement.length > 0) {
      let video = $(videoId)[0];
      video.play();
    }
  }

  function video_mute_unmute(unmuteId, muteId, videoId) {
    const videoElement = $(videoId);
    if (videoElement.length > 0) {
      const section = videoElement.closest('.rm-section-js');
      if (section.length === 0) return;

      const rm_unmute = section.find(unmuteId);
      const rm_mute = section.find(muteId);
      const video = videoElement[0]; // DOM element

      // Wait for metadata to load
      video.addEventListener("loadedmetadata", () => {
        // Try to detect real audio track
        const hasAudio = Boolean(
          video.mozHasAudio || // Firefox
          (video.webkitAudioDecodedByteCount > 0) || // WebKit
          (video.audioTracks && video.audioTracks.length > 0) // Spec-compliant
        );

        if (!hasAudio) {
          console.log("No audio available in video");
          section.find('.rm-volume-control').css("display", "none");
          return;
        } else {
          console.log("Audio available in video");
          section.find('.rm-volume-control').css("display", "block");
        }

        // Attach click events
        rm_mute.on("click", function () {
          rm_unmute.css("display", "block");
          rm_mute.css("display", "none");
          video.muted = false;
        });

        rm_unmute.on("click", function () {
          rm_unmute.css("display", "none");
          rm_mute.css("display", "block");
          video.muted = true;
        });
      });
    }
  }

});
